module.exports = __webpack_public_path__ + "img/ic_trash.dcadfd6d.svg";